import { UserWms } from '../../interfaces/Picking/Picking'
import {
  GET_USER_DATA_EXITO,
  GET_USER_DATA
} from '../types/userDataActionsTypes'

export type UserDataAction = UserDatasActions | UserDatasActionsAsync

// Esto va a REDUX
export interface UserDatasActions {
  type: typeof GET_USER_DATA_EXITO
  userData: UserWms | undefined
  error: string | undefined
}

export const getUserDataAction = (
  userData?: UserWms,
  error?: string
): UserDatasActions => {
  return {
    type: GET_USER_DATA_EXITO,
    userData,
    error
  }
}

// Esto va a SAGA
export interface UserDatasActionsAsync {
  type: typeof GET_USER_DATA
}

export const getUserDataActionAsync = (): UserDatasActionsAsync => {
  return {
    type: GET_USER_DATA
  }
}
